module.exports = __webpack_public_path__ + "img/teamwork.feb49cd8.png";